<template>
  <!-- 物联网检测终端 -->
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>警报点</el-breadcrumb-item>
        <el-breadcrumb-item>物联网检测终端</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
      <el-form label-position="left" inline class="demo-table-expand" >
        <div class="tonghang">
          <el-form-item label="生产厂家">
            <span>{{iotInfo.producer}}</span>
          </el-form-item>
          <el-form-item label="安装者">
            <span>{{iotInfo.installer}}</span>
          </el-form-item>
        </div>

        <div class="tonghang">
          <el-form-item label="设备型号">
            <span>{{iotInfo.type}}</span>
          </el-form-item>
          <el-form-item label="物联卡号">
            <span>{{iotInfo.ICCID}} </span>
          </el-form-item>
        </div>
        <div class="tonghang">
          <el-form-item label="安装时间">
            <span><i class="el-icon-time"></i> {{iotInfo.installAt}}</span>
          </el-form-item>
          <el-form-item label="备注">
            <span>{{iotInfo.remark}}</span>
          </el-form-item>
        </div>

      </el-form>
      <br>
      <el-divider content-position="center">设备登录信息</el-divider>
      <el-form label-position="left" inline class="demo-table-expand" >
        <!--        <div class="tonghang" >-->
        <!--          <el-form-item label="" style="color: black;"></el-form-item>-->
        <!--        </div>-->
        <!--        <div class="tonghang" >-->
        <!--          <el-form-item label="设备信息" style="color: black;"></el-form-item>-->
        <!--        </div>-->
        <div class="tonghang" >
          <el-form-item label="设备ID">
            <span>{{AlarmPointStaticInfomation.devID}}</span>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" size="medium" style="margin-top: 30px;" @click="openAltStaticInformation()">信息更改</el-button>
          <el-button @click="openAddDeviceUserDialog()" type="primary" style="margin-top: 15px;">设备ID修改</el-button>
          <el-dialog :visible.sync="updateAlarmVisible" @close="closeUpdateAlarmDialog()" v-if="updateAlarmVisible">
            <template slot="title">
              <span>修改物联网检测终端信息</span>
            </template>
            <el-form :label-position="labelPosition" label-width="120px" :model="formIotInfo" :ref="formIotInfo" :rules="rulesOfAltStaticInformation">
              <el-form-item label="生产厂家" prop="producer">
                <el-input v-model="formIotInfo.producer"></el-input>
              </el-form-item>
              <el-form-item label="物联卡号" prop="ICCID">
                <el-input v-model="formIotInfo.ICCID"></el-input>
              </el-form-item>
              <el-form-item label="设备型号" prop="type">
                <el-input v-model="formIotInfo.type"></el-input>
              </el-form-item>
              <el-form-item label="安装人" prop="installer">
                <el-input v-model="formIotInfo.installer"></el-input>
              </el-form-item>
              <el-form-item label="安装时间" prop="installAt">
                <el-date-picker v-model="formIotInfo.installAt" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input v-model="formIotInfo.remark"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="closeUpdateAlarmDialog">取 消</el-button>
              <el-button type="primary" @click="checkAltStaticInformation">确定修改</el-button>
            </div>
          </el-dialog>
        </el-form-item>
      </el-form>
    </el-card>
    <AddDeviceUser :add-device-user-dialog-visible="addDeviceUserDialogVisible" :dev-i-d="AlarmPointStaticInfomation.devID" @feedBack="getAddDeviceUserFeedBack"></AddDeviceUser>
  </div>
</template>

<script>
  import AlarmViewNav from './AlarmViewNav'
  import AddDeviceUser from './device/AddDeviceUser'
  export default {
    name: 'IOTTerminal',
    components: { AddDeviceUser, AlarmViewNav },
    data(){
      return {
        addDeviceUserDialogVisible: false,
        iotInfo:{
          "producer":"",
          "ICCID":"",
          "type":"",
          "installer":"",
          "installAt":"",
          "remark":""
        },
        formIotInfo:{
          "producer":"",
          "ICCID":"",
          "type":"",
          "installer":"",
          "installAt":"",
          "remark":""
        },
        rulesOfAltStaticInformation:{
          ICCID:[{required: true, message:'物联卡号不能为空', trigger: 'change'}],
          type:[{required: true, message:'设备型号不能为空', trigger: 'change'}],
          producer:[{required: true, message:'生产厂家不能为空', trigger: 'change'}],
          installer:[{required: true, message:'安装人不能为空', trigger: 'change'}],
          installAt:[{required: true, message:'安装时间不能为空', trigger: 'change'}],
          // remark:[{required: true, message:'备注不能为空', trigger: 'change'}],
        },
        AltStaticInformation:{
          "version": 1,
          "method": "alarmpoint2.AltStaticInformation",
          "params": {
            "alarmPointId":"",
            "option":3,
            "content":{
              "ICCID":"",
              "type":"",
              "producer":"",
              "installer":"",
              "installAt":"",
              "remark":"",
            }
          },
          "token": "#",
          "id": 0
        },
        // 查看警报点静态信息
        GetStaticInformation:{
          "version": 1,
          "method": "alarmpoint2.GetStaticInformation",
          "params": {
            "alarmPointId":"#"
          },
          "token": "#",
          "id": 0
        },
        // 查询设备账户
        GetDeviceUser:{
          "version": 1,
          "method": "user.GetDeviceUser",
          "params": {
            "devID":"",
          },
          "token": "",
          "id": 0
        },
        DeviceUser:{
          "_id":"",
          "username":"",
          "password":"",
          "devID":"",
          "deletedFlag":"",
          "userType":"",
          "token":""
        },
        labelPosition: 'right',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        // labelPosition:'left',
        updateAlarmVisible: false,
      }
    },
    methods:{
      checkAltStaticInformation(){
        this.$refs[this.AltStaticInformation.params.content].validate((valid)=>{
          if(valid){
            this.altStaticInformation();
          }
          else{
            return false;
          }
        })
      },
      openAltStaticInformation(){
        let a = true;
        this.updateAlarmVisible = a;
      },
      getAlarmPointStaticInfomation(){
        // console.log('这是token');
        // console.log(localStorage.getItem('token'));
        this.GetStaticInformation.token = localStorage.getItem('token');
        this.GetStaticInformation.params.alarmPointId = window.sessionStorage.getItem("alarmPointId");
        this.$axios.post(this.$mainUrl, this.GetStaticInformation).then(res=> {
          if(res.data.hasOwnProperty('result')){
            if(res.data.result.monitorInformation){
              this.iotInfo = res.data.result.monitorInformation;
            }
            //this.iotInfo = res.data.result.monitorInformation;
            this.formIotInfo = this.iotInfo;
          }else{
            this.$message({
              type:'error',
              message:'获取警报点静态信息失败，' + res.data.error.message
            })
          }
        }).catch(error=>{
          this.$message({
            type:'error',
            message: error
          })
        })
      },
      altStaticInformation(){
        this.AltStaticInformation.token = localStorage.getItem('token');
        this.AltStaticInformation.params.alarmPointId = window.sessionStorage.getItem("alarmPointId");
        this.AltStaticInformation.params.content = this.formIotInfo;
        this.AltStaticInformation.params.content.version = parseFloat(this.AltStaticInformation.params.content.version)
        this.$axios.post(this.$mainUrl, this.AltStaticInformation).then(res =>{
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type: 'success',
              message: '编辑警报点静态信息成功'
            })
            console.log('该查看了');
            this.closeUpdateAlarmDialog();
            this.getAlarmPointStaticInfomation();
          }else{
            this.$message({
              type: 'error',
              message: '编辑警报点静态信息失败，' + res.data.error.message
            })
          }
        })

      },
      // 获取设备账户
      getDeviceUser(){
        this.GetDeviceUser.token =  localStorage.getItem('token');
        this.GetDeviceUser.params.devID = window.sessionStorage.getItem("devIDForHardInfo");
        console.log('获取设备账户请求');
        console.log(this.GetDeviceUser)
        this.$axios.post(this.$mainUrl, this.GetDeviceUser).then(res=>{
          console.log('添加维修记录请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result') && res.data.result.hasOwnProperty('deviceUser')){
            this.DeviceUser = res.data.result.deviceUser;

          }else if(res.data.hasOwnProperty('error')){
            this.$message({
              type: 'error',
              message: '获取设备账户失败，' + res.data.error.message
            })
          }
        })
      },
      closeUpdateAlarmDialog(){
        this.getAlarmPointStaticInfomation();
        this.updateAlarmVisible = false;
      },
      openAddDeviceUserDialog(){
        this.addDeviceUserDialogVisible = true
      },
      getAddDeviceUserFeedBack(addDeviceUserDialogVisible){
        this.addDeviceUserDialogVisible = addDeviceUserDialogVisible;
        this.getDeviceUser();
      }
    },
    computed:{
      monitorInformation(){
        if(this.$store.state.AlarmPointStaticInfomation.result.hasOwnProperty('monitorInformation')){
          return this.$store.state.AlarmPointStaticInfomation.result.monitorInformation;
        }else{
          return {
            producer:'', type:'', ICCID:'', installAt:'', installer:'', remark:''
          }
        }
      },
      AlarmPointStaticInfomation(){
        return this.$store.state.AlarmPointStaticInfomation.result;
      }
    },
    mounted(){
      this.getAlarmPointStaticInfomation()
      // this.monitorInformation = this.$store.state.AlarmPointStaticInfomation.result.monitorInformation;
      this.getDeviceUser();
    }
  }
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .tonghang{
    display: flex;
    flex-wrap: nowrap;
  }
</style>
